import {CLIENT_ID, AI_TOOLKIT_URL} from './constants.js'

const env = process.env.REACT_APP_ENV
export const serviceEndPoint = (path) => {
  return AI_TOOLKIT_URL[env] + path;
}
export const clientId = () => {
  return CLIENT_ID[env];
}

export default { serviceEndPoint, clientId };
